// Same-origin in dev (proxied by setupProxy.js). Override via REACT_APP_API_URL in production.
const socketBaseUrl = process.env.REACT_APP_API_URL || '';

export default socketBaseUrl;
